import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { isMyJobsOnlyAtom } from './filterAtom';
import { dashboardAtom } from './atoms';

// This hook only shares the status configuration data
export const useStatusConfig = () => {
  const dashboardData = useAtomValue(dashboardAtom);
  const isMyJobsOnly = useAtomValue(isMyJobsOnlyAtom);

  const statusConfig = useMemo(
    () => [
      {
        count: dashboardData?.total || 0,
        label: isMyJobsOnly ? 'My' : 'All',
        status: 'ANY',
      },
      {
        count: dashboardData?.pending || 0,
        label: 'Pending',
        status: 'PENDING',
      },
      {
        count: dashboardData?.inProgress || 0,
        label: 'In Progress',
        status: 'IN_PROGRESS',
      },
      { count: dashboardData?.failed || 0, label: 'Failed', status: 'FAILED' },
      {
        count: dashboardData?.stopped || 0,
        label: 'Stopped',
        status: 'STOPPED',
      },
      {
        count: dashboardData?.stopping || 0,
        label: 'Stopping',
        status: 'STOPPING',
      },
      {
        count: dashboardData?.finished || 0,
        label: 'Finished',
        status: 'FINISHED',
      },
      {
        count: dashboardData?.finished_error || 0,
        label: 'Finished Error',
        status: 'FINISHED_ERROR',
      },
    ],
    [dashboardData, isMyJobsOnly]
  );

  return { statusConfig };
};
